import ValueRenderer from './ValueRenderer'

export default function ChangeRenderer ({ type, change }) {
  if (!change[0] && change[1]) {
    // -- Added
    return (
      <div className='change'>
        ADDED
        <span className='arrow'>→</span>
        <ValueRenderer
          value={change[1]}
          type={type}
          className='after'
        />
      </div>
    )
  }
  if (change[0] && !change[1]) {
    // -- Deleted
    return (
      <div className='change'>
        DELETED
        <span className='arrow'>→</span>
        <ValueRenderer
          value={change[0]}
          type={type}
          className='before'
        />
      </div>
    )
  }
  if (change[0] && change[1]) {
    // -- Changed
    return (
      <div className='change'>
        <ValueRenderer
          value={change[0]}
          type={type}
          className='before'
        />
        <span className='arrow'>→</span>
        <ValueRenderer
          value={change[1]}
          type={type}
          className='after'
        />
      </div>
    )
  }
}
